import * as howler from 'howler'
import { log } from './log-sidecar'
import { pubSub } from './pubSub-sidecar'
// import { settings } from '../main/se'
import { l } from '../lib/imports'
import { settings } from './settings-sidecar'
import { Howl } from 'howler'

// export interface ISoundSprite {
//   once: (event: 'load', cb: () => void) => void
// //   on: (event: 'loaderror' | 'end', cb: (id: string, err: any) => void) => void
// //   stop: (soundKey?: string) => void
// //   play: (soundKey?: string) => void
// //   mute: (mute: boolean) => void
// // }

let soundSprite: Howl | null = null
let musicSprite: Howl | null = null

const logNamespace = 'soundGeneric'

export function getMusicSprite() {
  return musicSprite
}

export function getSoundSprite() {
  return soundSprite
}

export function load(jsonAudioSprite: any, callbackOnLoaded?: () => void) {
  soundSprite = new howler.Howl({
    src: jsonAudioSprite.urls,
    sprite: jsonAudioSprite.sprite,
  })
  if (soundSprite) {
    soundSprite.once('load', () => {
      if (callbackOnLoaded) {
        callbackOnLoaded()
      }
    })
    soundSprite.on('loaderror', (id: number, err: any) => {
      log.x(logNamespace, 'error loading sound', id, err)
    })
  }
}

export function playMusic(
  song: string,
  loop = true,
  cb: (() => void) | null = null,
) {
  log.x(logNamespace, 'play music', song)
  if (musicSprite) {
    musicSprite.stop()
    musicSprite = null
  }

  musicSprite = new howler.Howl({
    src: [song + '.ogg', song + 'mp3'],
    autoplay: true,
    loop: loop,
    volume: 0.33,
    mute: settings.get().muteMusic,
  })
  if (musicSprite) {
    //musicSprite.once('load', () => {
    //musicSprite.play()
    //})
    musicSprite.on('loaderror', (id: number, err: any) => {
      // console.log('howl', 'loaderror', id, err)
      log.x(logNamespace, 'error loading music', song, id, err)
    })
    if (cb) {
      musicSprite.on('end', () => {
        cb()
      })
    }
  }
}

export function isSoundMuted() {
  return settings.get().muteSound
}

export function playOn(_soundSprite: Howl, soundKey: string) {
  if (isSoundMuted()) {
    return -1
  }

  log.x(logNamespace, 'play', soundKey)
  return _soundSprite.play(soundKey)
}

export function play(soundKey: string) {
  log.x(logNamespace, 'play sound', soundKey)
  if (isSoundMuted() || !soundSprite) {
    return -1
  }

  log.x(logNamespace, 'play', soundKey)

  let id = soundSprite.play(soundKey)
  soundSprite.rate(1, id)
}

export function playWithRandomRate(
  soundKey: string,
  baseRate: number = 1,
  variance: number = 0.125,
) {
  log.x(logNamespace, 'play sound w rate', soundKey)
  if (isSoundMuted() || !soundSprite) {
    return -1
  }

  log.x(logNamespace, 'play', soundKey)

  let id = soundSprite.play(soundKey)
  let rate = baseRate + l.random(-variance, variance, true)
  soundSprite.rate(rate, id)
}

export function stop(id: number) {
  if (soundSprite) {
    soundSprite.stop(id)
  }
}

export function stopAllSounds() {
  if (soundSprite) {
    soundSprite.stop()
  }
}

function updateMusicMute() {
  if (!musicSprite) {
    return
  }
  musicSprite.mute(settings.get().muteMusic)
}

pubSub.on('settings:update', () => {
  updateMusicMute()
  if (settings.get().muteSound) {
    stopAllSounds()
  }
})
